<script lang="ts">
import { clearToasts } from "mosha-vue-toastify";
import { defineComponent, type PropType } from 'vue';
import type { RosterType } from '@interfaces/roster_type';
import type { StructureType } from '@interfaces/structure_type';

declare const localStorage: Storage;

export default defineComponent({
  name: 'LoadPresavedToast',
  data() {
    return {
      presaved_roster: <RosterType>JSON.parse(localStorage.getItem("roster") || '{}'),
    };
  },
  props: {
    roster: {
      type: Object as PropType<RosterType>,
      required: true
    },
    structure: {
      type: Object as PropType<StructureType>,
      required: true
    },
    i18n: {
      type: Function,
      required: true
    }
  },
  methods: {
    loadPresaved() {
      this.loadRoster();
      this.$emit('load-presaved', this.roster);
    },
    loadRoster() {
      this.structure.domain = this.presaved_roster.structure.domain;
      this.structure.faction = this.presaved_roster.structure.faction;
      this.structure.hero = this.presaved_roster.structure.hero;
      this.structure.units = this.presaved_roster.structure.units;
      this.structure.spells = this.presaved_roster.structure.spells;
      this.structure.equipment = this.presaved_roster.structure.equipment;
      this.structure.point_cost = this.presaved_roster.structure.point_cost;
      // keep compatibility with older drafts
      this.structure.max_points = this.presaved_roster.structure.max_points ?? this.presaved_roster.structure.maxPoints;

      this.roster.name = this.presaved_roster.name;
      this.roster.points_left = this.presaved_roster.points_left;
      this.roster.points_overall = this.presaved_roster.points_overall;
      this.roster.roster_format_id = this.presaved_roster.roster_format_id;

      // Once loaded, remove legacy saved roster so it doesn't keep popping up
      localStorage.removeItem("roster");
      clearToasts();
    },
    discardRoster() {
      localStorage.removeItem("roster");
      clearToasts();
    },
  }
});
</script>

<template>
  <p class="text-center">{{ i18n('toast.presaved.message') }}</p>

  <div class="buttons">
    <button class="button mr-1" @click="loadRoster">{{ i18n('toast.presaved.load') }}</button>
    <button class="button mr-1 button-unwanted" @click.stop.prepend="discardRoster">
      {{ i18n('toast.presaved.discard') }}
    </button>
  </div>
</template>

<!-- <style>
.mosha__toast__content {
  color: var(--light-base);

  .mosha__toast__content__progress {
    background-color: rgba(14, 13, 13, 0.6);
    /*background-color: rgba($color: #FFFFFF, $alpha: 0.6);*/
  }
}
.mosha__toast__close-icon::before {
  color: var(--light-base);
}
.mosha__toast__close-icon:hover::before {
  color: grey;
}
.mosha__toast.success {
  background-color: #06d6a0;
}
.mosha__toast.warning {
  background-color: #ffc43d;
}
.mosha__toast.info {
  background-color: #1b9aaa;
}
.mosha__toast.danger {
  background-color: #ef476f;
}
.mosha__toast.default {
  background-color: var(--dark-base) !important;
}
.mosha__toast.default .mosha__toast__progress {
  background-image: -o-linear-gradient(315deg, #6e5224 0%, #cb9b52 100%) !important;
  background-image: linear-gradient(-225deg, #6e5224 0%, #cb9b52 100%) !important;
}
.mosha__toast.default .mosha__toast__content {
  color: var(--light-base);
}
.mosha__toast.default .mosha__toast__close-icon::before {
  color: var(--light-base);
}
.mosha__toast.default .mosha__toast__close-icon:hover::before {
  color: var(--light-base);
}
</style> -->

<style scoped>
.buttons {
  display: flex;
  align-items: center;
  justify-content: center;

  .button {
    display: inline-block;
    margin: 0 auto;
  }

  .button-unwanted {
    background-color: #6e5224;
    color: #303030;
  }
}
</style>
